import { render } from "./addpurchase.vue?vue&type=template&id=500250f9&scoped=true"
import script from "./addpurchase.vue?vue&type=script&lang=js"
export * from "./addpurchase.vue?vue&type=script&lang=js"

import "./addpurchase.vue?vue&type=style&index=0&id=500250f9&scoped=true&lang=css"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-POP-PROD\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-500250f9"]])

export default __exports__